import { render, staticRenderFns } from "./InsightCategoryArticles.vue?vue&type=template&id=6ae80446&scoped=true&"
import script from "./InsightCategoryArticles.vue?vue&type=script&lang=js&"
export * from "./InsightCategoryArticles.vue?vue&type=script&lang=js&"
import style0 from "./InsightCategoryArticles.vue?vue&type=style&index=0&id=6ae80446&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae80446",
  null
  
)

export default component.exports